import React from "react";

import { Container, Text, TextWrapper, Title, TitleBox, Wrapper, } from "./styles";

export const TextBox = ({ data, color, background, bigText, marketing, sticky = false }) => (
  <Container color={color} className={marketing ? 'marketing' : ''} background={background}>
    <Wrapper>
      <TitleBox className={sticky ? "sticky" : ''}>
        <Title color={color}>{data.title}</Title>
      </TitleBox>
      <TextWrapper>
        <Text className={bigText ? 'bigText' : ''} color={color}>{data.text}</Text>
      </TextWrapper>
    </Wrapper>
  </Container>
);
